type StringByPattern = {
  str: string;
  pattern?: string;
};

export function formatStringByPattern({
  str,
  pattern = "X (XXX) XXX-XXXX",
}: StringByPattern) {
  let formattedString = "";
  let strIndex = 0;

  for (let i = 0; i < pattern.length; i++) {
    if (pattern[i] === "X") {
      while (strIndex < str.length && !/\d/.test(str[strIndex])) {
        strIndex++;
      }
      if (strIndex < str.length) {
        formattedString += str[strIndex];
        strIndex++;
      }
    } else {
      formattedString += pattern[i];
    }
  }

  return formattedString;
}

export function unformatStringByPattern({
  str,
  pattern = "X (XXX) XXX-XXXX",
}: StringByPattern) {
  let rawString = "";
  let patternIndex = 0;

  for (let i = 0; i < str.length; i++) {
    if (pattern[patternIndex] === "X") {
      if (/\d/.test(str[i])) {
        rawString += str[i];
        patternIndex++;
      }
    } else {
      if (pattern[patternIndex] === str[i]) {
        patternIndex++;
      }
    }
  }

  return rawString;
}

export function formatPhoneNumber(value: string) {
  const rawValue = value.replace(/\D/g, "");

  let formattedValue = "";

  if (rawValue.length > 0) {
    formattedValue += "+" + rawValue.substring(0, 1);
  }
  if (rawValue.length > 1) {
    formattedValue += " (" + rawValue.substring(1, 4);
  }
  if (rawValue.length >= 4) {
    formattedValue += ") " + rawValue.substring(4, 7);
  }
  if (rawValue.length >= 7) {
    formattedValue += "-" + rawValue.substring(7, 11);
  }

  return formattedValue;
}
